import React from 'react';
import { useDashboardOrders } from './hooks/useDashboardOrders';
import FinancialBunkerCard from './components/FinancialBunkerCard';
import { MetricCard } from './components/MetricCard';
import MainLayout from '../../components/layout/MainLayout';
import { FiDollarSign, FiBox, FiCheckCircle, FiActivity, FiTrendingUp, FiPieChart } from 'react-icons/fi';

export default function DashboardPage() {
    const { stats, loading } = useDashboardOrders();

    if (loading) {
        return (
            <div className="h-screen flex items-center justify-center bg-[var(--bg-main)] font-black text-[var(--accent-color)] animate-pulse tracking-[1em]">
                SINCRONIZANDO...
            </div>
        );
    }

    const formatCurrency = (val) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val || 0);

    return (
        <MainLayout>
            <div className="p-8 md:p-16 space-y-12 max-w-[1600px] mx-auto transition-all duration-500"
                 style={{ backgroundColor: 'var(--bg-main)', color: 'var(--text-primary)' }}>
                
                <header className="flex flex-col md:flex-row md:items-end justify-between gap-6 border-b border-[var(--border-color)] pb-12">
                    <div>
                        <h1 className="text-6xl font-black tracking-tighter uppercase italic">
                            WAR <span className="text-[var(--accent-color)]">ROOM</span>
                        </h1>
                        <p className="text-xs font-black uppercase tracking-[0.6em] opacity-40 mt-3 border-l-2 border-[var(--accent-color)] pl-4">
                            Inteligência & Resultados
                        </p>
                    </div>
                    
                    <div className="flex items-center gap-4 bg-[var(--bg-card)] p-4 rounded-2xl border border-[var(--border-color)] shadow-sm">
                        <div className="w-3 h-3 rounded-full bg-green-500 animate-pulse" />
                        <span className="text-[10px] font-black uppercase tracking-widest opacity-60">
                            Radar de Vendas: ATIVO
                        </span>
                    </div>
                </header>

                <div className="grid grid-cols-1 xl:grid-cols-4 gap-8">
                    <FinancialBunkerCard 
                        mrr={stats?.receitaGeral} 
                        payout={stats?.receitaProjecao} 
                    />
                </div>

                {/* VOLUME DE PEDIDOS */}
                <div className="space-y-6">
                    <h2 className="text-xl font-black uppercase tracking-widest opacity-50 border-b border-white/5 pb-2">Volume de Pedidos (Mês Atual)</h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <MetricCard 
                            title="Pedidos Totais (Geral)" 
                            value={stats?.numeroDePedidosGerais || 0} 
                            icon={FiBox} 
                            color="#3b82f6" 
                        />
                        <MetricCard 
                            title="Na Esteira (Ativos)" 
                            value={stats?.numeroDePedidosEsteira || 0} 
                            icon={FiActivity} 
                            color="#f59e0b" 
                        />
                        <MetricCard 
                            title="Concluídos (Sucesso)" 
                            value={stats?.numeroDePedidosConcluidos || 0} 
                            icon={FiCheckCircle} 
                            color="#10b981" 
                        />
                    </div>
                </div>

                {/* RECEITAS DETALHADAS */}
                <div className="space-y-6">
                    <h2 className="text-xl font-black uppercase tracking-widest opacity-50 border-b border-white/5 pb-2">Desdobramento de Receita (MRR)</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        <MetricCard 
                            title="Receita Geral (Total)" 
                            value={formatCurrency(stats?.receitaGeral)} 
                            icon={FiPieChart} 
                            color="#8b5cf6" 
                        />
                        <MetricCard 
                            title="Receita na Esteira" 
                            value={formatCurrency(stats?.receitaEsteira)} 
                            icon={FiTrendingUp} 
                            color="#f59e0b" 
                        />
                        <MetricCard 
                            title="Receita Concluída" 
                            value={formatCurrency(stats?.receitaConcluidos)} 
                            icon={FiDollarSign} 
                            color="#10b981" 
                        />
                        <MetricCard 
                            title="Projeção Estimada" 
                            value={formatCurrency(stats?.receitaProjecao)} 
                            icon={FiTrendingUp} 
                            color="#34d399" 
                        />
                    </div>
                </div>

                <footer className="pt-20 opacity-20 text-[9px] font-black uppercase tracking-[0.5em] text-center">
                    TIM Brasil Security &copy; 2026 | Operação Marketplace Dashboard
                </footer>
            </div>
        </MainLayout>
    );
}